import React from 'react';
// @ts-ignore
import QRImage from '../../assets/QR.png';
import { FaWhatsapp } from 'react-icons/fa';
const CTA = () => {
  return (
    <section id="BookDemo" className="bg-[#9dd679] py-20">
    {/* Start Contact Area */}



  <div className="relative container mx-auto px-4">
    
    {/* Heading */}
    <div className="flex justify-center text-center">
      <div className="w-full md:w-2/3 lg:w-1/2">
        <h2 className="text-4xl text-black mb-4">
          Scan QR to Book a <span className="text-4xl font-semibold text-black">FREE DEMO</span>
        </h2>
        <p className="text-black">
          Take your Restaurants & Hotels on a Digital Journey.
        </p>
      </div>
    </div>

    {/* QR Code */}

    <div className="mt-10 flex justify-center text-center">
  <div className="w-full md:w-2/3 lg:w-1/2">
    <img
      className="mx-auto w-1/2"
      src={QRImage}
      alt="QR Code"
    />

    {/* Mobile-only message and button */}
    <div className="block md:hidden mt-6">
      <p className="text-gray-700 text-sm px-4">
        I think you are on mobile device, Click below button instead of scanning.
      </p>

      <a
        href="https://wa.me/918097588099?text=Hi%20I%20am%20interested%20to%20know%20more%20about%20Zafflo."
        target="_blank"
        rel="noopener noreferrer"
       className="inline-flex items-center mt-4 px-8 py-2 border-2 border-[#6cbb23] text-black hover:bg-[#6cbb23] hover:text-white rounded-full transition duration-300"
      >
        <span className="mr-2"><FaWhatsapp className="w-5 h-5" /></span>
        Book Free Demo
      </a>
    </div>
  </div>
</div>



   
    
  </div>

{/* End Contact Area */}

    </section>
  );
};

export default CTA;